import * as t from "io-ts";
import { ElementDependencyAndConditionV } from "@/types/elements";

export const GlobalGeneratedCssFilePathsV = t.partial({
  globalSettingsCssFilePath: t.string,
  globalSelectorsCssFilePath: t.string,
  defaultCssForAllElementsFilePath: t.string
});

// this type also exists in Psalm
export type GlobalGeneratedCssFilePaths = t.TypeOf<
  typeof GlobalGeneratedCssFilePathsV
>;

export const PostGeneratedCssFilePathsV = t.partial({
  postCssFilePath: t.string,
  postDefaultsCssFilePath: t.string
});

// this type also exists in Psalm
export type PostGeneratedCssFilePaths = t.TypeOf<
  typeof PostGeneratedCssFilePathsV
>;

export const PostAssetsWithoutDependenciesV = t.type({
  postsGeneratedCssFilePaths: t.record(t.string, PostGeneratedCssFilePathsV)
});

export const PostAssetsV = t.intersection([
  PostAssetsWithoutDependenciesV,
  t.type({
    dependencies: ElementDependencyAndConditionV
  })
]);

// this type also exists in Psalm
export type PostAssets = t.TypeOf<typeof PostAssetsV>;

// this type also exists in Psalm
export type PostAssetsWithoutDependencies = t.TypeOf<
  typeof PostAssetsWithoutDependenciesV
>;
